
import EmailIcon from '@material-ui/icons/Email';

const Email : React.FC = () => {
    return (
        <EmailIcon style={{ color: "white"}} />
    )
}

export default Email;